import { Language } from "@excalidraw/excalidraw/types/i18n";

const languageList: Language[] = [
  {
    code: "id-ID",
    label: "Bahasa Indonesia",
  },
  {
    code: "ca-ES",
    label: "Català",
  },
  {
    code: "de-DE",
    label: "Deutsch",
  },
  {
    code: "en",
    label: "English",
  },
  {
    code: "es-ES",
    label: "Español",
  },
  {
    code: "eu-ES",
    label: "Euskara",
  },
  {
    code: "fr-FR",
    label: "Français",
  },
  {
    code: "it-IT",
    label: "Italiano",
  },
  {
    code: "ku-TR",
    label: "Kurdî",
  },
  {
    code: "lv-LV",
    label: "Latviešu",
  },
  {
    code: "hu-HU",
    label: "Magyar",
  },
  {
    code: "nl-NL",
    label: "Nederlands",
  },
  {
    code: "nb-NO",
    label: "Norsk bokmål",
  },
  {
    code: "nn-NO",
    label: "Norsk nynorsk",
  },
  {
    code: "oc-FR",
    label: "Occitan",
  },
  {
    code: "pl-PL",
    label: "Polski",
  },
  {
    code: "pt-PT",
    label: "Português",
  },
  {
    code: "pt-BR",
    label: "Português Brasileiro",
  },
  {
    code: "ro-RO",
    label: "Română",
  },
  {
    code: "sk-SK",
    label: "Slovenčina",
  },
  {
    code: "sl-SI",
    label: "Slovenščina",
  },
  {
    code: "fi-FI",
    label: "Suomi",
  },
  {
    code: "sv-SE",
    label: "Svenska",
  },
  {
    code: "kab-KAB",
    label: "Taqbaylit",
  },
  {
    code: "tr-TR",
    label: "Türkçe",
  },
  {
    code: "el-GR",
    label: "Ελληνικά",
  },
  {
    code: "ru-RU",
    label: "Русский",
  },
  {
    code: "uk-UA",
    label: "Українська",
  },
  {
    code: "mr-IN",
    label: "मराठी",
  },
  {
    code: "pa-IN",
    label: "ਪੰਜਾਬੀ",
  },
  {
    code: "ja-JP",
    label: "日本語",
  },
  {
    code: "zh-CN",
    label: "简体中文",
  },
  {
    code: "zh-TW",
    label: "繁體中文",
  },
  {
    code: "ko-KR",
    label: "한국어",
  },
];

export default languageList;
